import { ACTION_TYPES } from '../../../utils/Constants';
import { myLog } from '../../../utils/Utility';
import Client from '../../../utils/ClientVOIM';
import URL from '../../../utils/URL';
import { RESPONSE_CONSTANT } from '../../../utils/ResponseConstant';

/**
 * Get Dashboard Details
 * @param {Function} callBack
 */
export const getDashboardDetails = (callBack) => {
    return function (dispatch) {
        Client.get(URL.COMMON_ENDPOINT.DASHBOARD_DETAILS, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PATIENT.DASHBOARD,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
};

// student dashboard appointment list api
export const getAppointmentDetails = (callBack) => {
    return function (dispatch) {
        Client.get(URL.COMMON_ENDPOINT.DASHBOARD_APPOINTMENT_DETAILS, null, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.PATIENT.DASHBOARD_APPOINTMENT,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====DashDetails error===????', error);
                callBack(false);
            });
    };
};
export const getStudentEducator = (values, callBack) => {
    return function (dispatch) {
        Client.get(URL.IM_STUDENT.GET_STUDENTS_EDUCATOR, values, true)
            .then((response) => {
                callBack(response);
                if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                    dispatch({
                        type: ACTION_TYPES.STUDENT.GET_STUDENTS_EDUCATOR,
                        payload: response.response,
                    });
                }
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};

export const getStudentEducatorSubject = (id, values, callBack) => {
    return function () {
        Client.get(`${URL.IM_STUDENT.GET_STUDENTS_EDUCATOR_SUBJECT}/${id}`, values, true)
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};
export const getStudentEducatorSubcategory = (values, callBack) => {
    return function () {
        Client.get(
            `${URL.IM_STUDENT.GET_STUDENTS_EDUCATOR_SUBCATEGORY}/${values.educatorId}/subject/${values.subjectId}`,
            values,
            true
        )
            .then((response) => {
                callBack(response);
            })
            .catch((error) => {
                myLog('====UserList error===????', error);
                callBack(false);
            });
    };
};
